//@flow

import type {AttachmentTypes} from "../Attachment/Attachment";

export default class InKindDonation {
    id:string;
    projectId: string;
    tenantId: string;
    vendorId:string;
    donor:InKindDonationDonor;
    estimatedValue:string;
    donationDate:string;
    notes:string;
    attachment:InKindDonationAttachment;

    constructor(
        id:string,
        projectId: string,
        tenantId: string,
        vendorId:string,
        donor:InKindDonationDonor,
        estimatedValue:string,
        donationDate:string,
        notes:string,
        attachment:InKindDonationAttachment,
    ){
        this.id = id;
        this.projectId = projectId;
        this.tenantId = tenantId;
        this.vendorId = vendorId;
        this.donor = donor;
        this.estimatedValue = estimatedValue;
        this.donationDate = donationDate;
        this.notes = notes;
        this.attachment = attachment;
    }
}

export class CreateInKindDonationRequest{
    projectId: string;
    vendorId: string;
    estimatedValue:?string;
    donationDate:?string;
    notes:?string;
    attachment:?CreateInKindDonationAttachment;

    constructor(
    projectId: string,
    vendorId: string,
    estimatedValue:?string,
    donationDate:?string,
    notes:?string,
    attachment:?CreateInKindDonationAttachment,
    ) {
        this.projectId = projectId;
        this.vendorId = vendorId;
        this.estimatedValue = estimatedValue;
        if(donationDate)
        this.donationDate = donationDate;
        this.notes = notes;
        if(attachment)
        this.attachment = attachment;
    }
}

export class UpdateInKindDonationRequest{
    projectId: string;
    donationId:string;
    vendorId:?string;
    estimatedValue:?string;
    donationDate:?string;
    notes:?string;
    attachment:?CreateInKindDonationAttachment;
    updateAttachment: ?boolean;
    deleteAttachment:?boolean;
    attachmentId:?string;

    constructor(
    projectId: string,
    donationId:string,
    vendorId:?string,
    estimatedValue:?string,
    donationDate:?string,
    notes:?string,
    attachment:?CreateInKindDonationAttachment,
    updateAttachment: ?boolean,
    deleteAttachment:?boolean,
    attachmentId:?string,
    ) {
        this.projectId = projectId;
        this.donationId = donationId;
        this.vendorId = vendorId;
        this.estimatedValue = estimatedValue;
        if(donationDate)
        this.donationDate = donationDate;
        this.notes = notes;
        if(attachment)
        this.attachment = attachment;
        this.updateAttachment = updateAttachment;
        this.deleteAttachment = deleteAttachment;
        this.attachmentId = attachmentId;
    }
}

export class InKindDonationDonor{
    id:string;
    name:string;

    constructor(id:string,name:string){
        this.id = id;
        this.name = name;
    }
}

export  class InKindDonationAttachment{
    id: string;
    projectId: string;
    title: ?string;
    description: ?string;
    tenantId: string;
    fileType: string;
    attachmentType: AttachmentTypes;
    getUrl: string;

    constructor(id: string,
                projectId: string,
                title: string,
                description: string,
                tenantId: string,
                fileType: string,
                attachmentType: AttachmentTypes,
                getUrl: string) {
        this.id = id;
        this.projectId = projectId;
        this.title = title;
        this.description = description;
        this.tenantId = tenantId;
        this.fileType = fileType;
        this.attachmentType = attachmentType;
        this.getUrl = getUrl;
    }
}

export  class CreateInKindDonationAttachment{
    projectId: string;
    title: ?string;
    description: ?string;
    fileType: string;
    contentType: ?string;
    payload:  string | Buffer;

    constructor(projectId: string, title: string, description: string, fileType: string, contentType: ?string, payload: string | Buffer) {
        this.projectId = projectId;
        this.title = title;
        this.description = description;
        this.fileType = fileType;
        if(contentType) this.contentType = contentType;
        this.payload = payload;
    }
}
